import { ComponentPropsWithoutRef, FC } from 'react';

type CloseIconProps = ComponentPropsWithoutRef<'svg'>;

export const CloseIcon: FC<CloseIconProps> = ({ fill, ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            {...props}
        >
            <path
                d="M4.11298 12.6106L3.40627 11.887L7.27646 8L3.40627 4.11298L4.11298 3.38943L8 7.27646L11.887 3.38943L12.5937 4.11298L8.72354 8L12.5937 11.887L11.887 12.6106L8 8.72354L4.11298 12.6106Z"
                fill={fill ?? 'currentColor'}
            />
        </svg>
    );
};
